import * as Yup from 'yup'

import { EMPTY_LIST } from '../../../../constants/common'
import { isFormArrayFieldsEqual } from '../../../../utils/formHelpers'
import {
  EntityActionTypeSelectOptionValue,
  getEntityActionTypeSelectOptions,
  isRemoveAllEntityActionType,
} from '../../../Entity'
import {
  FORM_FIELD_NAME_NO_CHANGED,
  formValidationSchemaNoChanged,
} from '../../../Form'
import { FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME } from '../../../Formik'

import {
  BUILDING_GROUP_EDIT_BUILDINGS_FIELD_NAME_BUILDING,
  BUILDING_GROUP_EDIT_BUILDINGS_FORM_TEST_NAME_EMPTY_LIST,
  EDIT_BUILDING_FORM_INITIAL_VALUES,
} from './BuildingGroupsEditBuildingsActionModal.constants'

export function getInitialValues(initialValue, itemAction) {
  const actionTypeOptions = getEntityActionTypeSelectOptions()

  return {
    ...EDIT_BUILDING_FORM_INITIAL_VALUES,
    [BUILDING_GROUP_EDIT_BUILDINGS_FIELD_NAME_BUILDING]: initialValue,
    [FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME]: itemAction
      ? actionTypeOptions[EntityActionTypeSelectOptionValue.Edit]
      : actionTypeOptions[EntityActionTypeSelectOptionValue.Add],
  }
}

export function getValidationSchema({ initialValues, itemAction }) {
  return Yup.object({
    [BUILDING_GROUP_EDIT_BUILDINGS_FIELD_NAME_BUILDING]: Yup.array().when(
      FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME,
      {
        is: actionType =>
          !isRemoveAllEntityActionType(actionType) && !itemAction,
        then: schema => schema.of(Yup.object()).min(1, true),
      }
    ),
  }).when(EMPTY_LIST, {
    is: () => itemAction,
    then: schema =>
      schema
        .concat(
          formValidationSchemaNoChanged({
            initialValues,
            isEqual: isFormArrayFieldsEqual,
            isEqualProps: {
              name: BUILDING_GROUP_EDIT_BUILDINGS_FIELD_NAME_BUILDING,
            },
          })
        )
        // An emptied list under "Edit" is not a saveable change — the backend
        // rejects it, so it surfaces as the common "make changes" notification.
        .test({
          name: BUILDING_GROUP_EDIT_BUILDINGS_FORM_TEST_NAME_EMPTY_LIST,
          test: function (values) {
            if (
              isRemoveAllEntityActionType(
                values[FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME]
              ) ||
              values[BUILDING_GROUP_EDIT_BUILDINGS_FIELD_NAME_BUILDING].length >
                0
            ) {
              return true
            }

            return this.createError({ path: FORM_FIELD_NAME_NO_CHANGED })
          },
        }),
  })
}
